import { useQuery } from '@tanstack/react-query';

import { fetchStripeClientSecret } from '@m/services/StripeService';

// Stripe setup intents expire after 24h — cache for 23h with a 1h buffer
const STRIPE_SECRET_CACHE_MS = 23 * 60 * 60 * 1000;

export function useStripeClientSecret(userId: number | null | undefined, enabled = true) {
  return useQuery({
    queryKey: ['stripeClientSecret', userId],
    queryFn: () => fetchStripeClientSecret(userId as number),
    enabled: !!userId && enabled,
    retry: 1,
    staleTime: STRIPE_SECRET_CACHE_MS,
    gcTime: STRIPE_SECRET_CACHE_MS,
  });
}
